<div class="header_second">
    <div class="Dashboard_head ">Edit Gallery
    </div>
</div>

<mat-card class="example-card card shadow">
    <mat-card-header style="border-bottom: 1px solid #ededed;">
        <mat-card-title>Gallery Cover Photo</mat-card-title>
    </mat-card-header>
    <img mat-card-image src="https://aieventzo.com/upload/{{event_id}}/gallery/{{image_name}}" style="margin: 10px auto 10px; width: 200px;
                height: 200px;">
    <mat-card-content>
        <mat-form-field appearance="outline">
            <mat-label>Title</mat-label>
            <input matInput placeholder="Enter Title" [(ngModel)]="title" [required]="true"
                [ngModelOptions]="{standalone: true}">
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label>Description</mat-label>
            <input matInput placeholder="Enter Description" [(ngModel)]="description" [required]="true"
                [ngModelOptions]="{standalone: true}">
        </mat-form-field>
    </mat-card-content>
    <mat-card-actions align="end">
        <button style="background: var(--primary-button);color:var(--primary-button-color);" mat-raised-button
            mat-raised-button (click)="updateImage()">Update Image</button>
    </mat-card-actions>
</mat-card>







<div class="card shadow p-3 mb-5 bg-white rounded">
    <h4>Images for Album {{title}}</h4>
    <div class="card-body">
        <div *ngIf="isOld1 == false">
            <img src="https://aieventzo.com/upload/{{event_id}}/gallery/{{this.imagePath}}" style="width: 100px;
                  height: 100px; margin:1rem;">
        </div>
        <label>Image</label>
        <div class="input-group">
            <div class="custom-file col-12">
                <div class="input-group mb-3">
                    <input type="file" class="form-control" id="inputGroupFile01" #file accept='image/*'
                        id="exampleInputFile" (change)="previewpimage(file.files)">
                    <button class="btn btn-outline-secondary" type="button" id="button-addon2" (click)='addimage()'>
                        Add Image</button>
                </div>
            </div>
        </div>



        <div class="row">
            <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6" *ngFor="let imageData of inqires">
                <mat-card class="example-card-image card shadow">
                    <img mat-card-image
                        src="https://aieventzo.com/upload/{{event_id}}/gallery/{{imageData.image_name}}">
                    <mat-card-actions>
                        <button type="button" class="btn btn-outline-danger" matTooltip="Delete"
                            (click)='deleteimage(imageData.img_id)'>DELETE</button>
                    </mat-card-actions>
                </mat-card>
            </div>
        </div>
    </div>
</div>